import styled, { css } from 'styled-components';
import { FontSizes } from '../../../common/typography/typography.styles';
import { CustomRadio } from '../../../common/radio/radio.styles';
import { BREAKPOINTS } from '../../../constants/breakpoints';

export const EmptyViewContainer = styled.div`
  display: flex;
  gap: 2.4rem;
  flex-direction: column;
  align-items: center;

  svg {
    margin-bottom: 1.2rem;
  }

  p {
    font-weight: 500;
    font-size: ${FontSizes.normal};
    line-height: 20px;
    letter-spacing: 0.5px;
  }

  button {
    max-width: fit-content;
  }
`;

export const AddressesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.6rem;

  @media (max-width: ${BREAKPOINTS.mobile.css}) {
    gap: 1.2rem;
  }
`;

interface AddressItemContainerProps {
  $isSelected?: boolean;
  $isLoading?: boolean;
  disabled?: boolean;
}
export const AddressItemContainer = styled.div<AddressItemContainerProps>`
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 1.2rem 1.2rem 1.2rem 1.6rem;
  border: 1px solid;
  border-radius: 1rem;
  border-color: ${({ theme, $isSelected }) =>
    $isSelected
      ? theme.colors.namedColors.primary
      : theme.colors.baseColors.grey25};
  letter-spacing: 0.5px;
  position: relative;
  ${({ $isLoading }) =>
    $isLoading
      ? css`
          background-color: rgba(255, 255, 255, 0.7);
        `
      : undefined}

  &:hover ${CustomRadio} {
    border-color: ${({ theme }) => theme.colors.radio.colorActive};
  }

  .spinnerOverlay {
    position: absolute;
    inset: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: inherit;
    /* background-color: rgba(255, 255, 255, 0.7); */
  }

  .controls {
    display: flex;
    gap: 1.2rem;
    align-items: center;

    .buttonControlIcon {
      border: none;
      background: none;
      cursor: pointer;
      padding: 0;
      display: flex;

      &:disabled {
        color: ${({ theme }) => theme.colors.baseColors.grey65};
      }
    }

    .edit {
      color: ${({ theme }) => theme.colors.baseColors.blue150};
    }

    .delete {
      color: ${({ theme }) => theme.colors.baseColors.red130};
    }
  }

  .topPart {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: ${FontSizes.medium};
      line-height: 2.2rem;
      font-weight: 700;

      color: ${({ $isLoading, theme }) =>
        $isLoading
          ? theme.colors.baseColors.grey100
          : theme.colors.baseColors.grey150};
    }

    .topRightPart {
      display: flex;
      align-items: center;
      gap: 1.2rem;

      .defaultPill {
        font-size: ${FontSizes.small};
        line-height: 1.6rem;
        font-weight: 500;
        color: ${({ theme }) => theme.colors.baseColors.blue150};
        padding: 2px 10px;
        background-color: ${({ theme }) => theme.colors.baseColors.blue0};
        border-radius: 24px;
      }
    }
  }

  .bottomPart {
    .description {
      font-size: ${FontSizes.normal};
      line-height: 2rem;
      font-weight: 500;
      margin-bottom: 1.2rem;

      color: ${({ $isLoading, theme }) =>
        $isLoading
          ? theme.colors.baseColors.grey100
          : theme.colors.baseColors.grey150};
    }

    .controls {
      justify-content: end;
    }
  }
`;
